module.exports = __webpack_public_path__ + "static/media/Chess_icon.bb50aea2.png";